import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./PostDetails.css";
import placeholder from "./assets/image.png";
import dateIcon from "./assets/svg/date.svg";
import chevronLeft from "./assets/svg/chevron-left-large.svg";
import chevronRight from "./assets/svg/chevron-right-large.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";
import Footer from '../Footer';

SwiperCore.use([Autoplay, Navigation, Pagination]);

export default function PostDetails() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [sidebarPosts, setSidebarPosts] = useState([]);
  const [relatedPosts, setRelatedPosts] = useState([]);

  useEffect(() => {
    fetch(`https://beszeljegyesulet.hu/wp/wp-json/wp/v2/posts?slug=${slug}&_embed`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.length) setPost(data[0]);
      })
      .catch((err) => console.error("Hiba:", err));
  }, [slug]);

  useEffect(() => {
    fetch(`https://beszeljegyesulet.hu/wp/wp-json/wp/v2/posts?_embed&per_page=12`)
      .then((res) => res.json())
      .then((data) => {
        const cleaned = Array.isArray(data) ? data.filter((p) => p.slug !== slug) : [];
        setSidebarPosts(cleaned.slice(0, 6));
        setRelatedPosts(cleaned.slice(6, 12));
      })
      .catch((err) => console.error("Hiba a listában:", err));
  }, [slug]);

  if (!post) return <div className="loading">Betöltés...</div>;

  const featured =
    post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || placeholder;

  const author = post._embedded?.author?.[0];
  const formattedDate = new Date(post.date).toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

console.log("Sidebar:", sidebarPosts.length, sidebarPosts);
console.log("Related:", relatedPosts.length, relatedPosts);


  return (
    <main className="postdetails">
      <div className="post-hero-wrap">
        <div
          className="post-hero"
          style={{ backgroundImage: `url(${featured})` }}
        />
      </div>

      <section className="post-content-wrapper">
        <article className="post-main">
          <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
          <div
            className="wp-content"
            dangerouslySetInnerHTML={{ __html: post.content.rendered }}
          />
        </article>

        <aside className="post-sidebar">
          <div className="sidebar-published">{formattedDate.toUpperCase()}</div>

          <div className="sidebar-author">
            <img
              src={author?.avatar_urls?.["96"] || placeholder}
              alt={author?.name || "Author"}
            />
            <div className="sidebar-author-info">
              <span className="name">{author?.name?.toUpperCase() || "-"}</span>
              <span className="role">Szerző</span>
            </div>
          </div>

          <div className="sidebar-swiper">
            <Swiper
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop
              pagination={{ clickable: true }}
              spaceBetween={16}
              slidesPerView={1}
            >
              {sidebarPosts.map((item) => {
                const img =
                  item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                  placeholder;
                const date = new Date(item.date).toLocaleDateString("hu-HU", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                });

                return (
                  <SwiperSlide key={item.id}>
                    <div className="sidebar-card">
                      <img
                        src={
                          item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                          placeholder
                        }
                        alt={item.title.rendered}
                        className="slide-img"
                      />
                      <div className="slide-content">
                        <div className="meta-item">
                          <div className="icon">
                            <img src={dateIcon} alt="Dátum" />
                          </div>
                          <span>
                            <b>
                              {new Date(item.date).toLocaleDateString("hu-HU", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </b>
                          </span>
                        </div>

                        <Link to={`/posts/${item.slug}`} style={{ textDecoration: "none" }}>
                          <h4 className="heading-sm" dangerouslySetInnerHTML={{ __html: item.title.rendered }} />
                        </Link>

                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.excerpt.rendered.slice(0, 140) + "...",
                          }}
                        ></p>

                        <Link to={`/posts/${item.slug}`} className="event-link">
                          Tudj meg többet{" "}
                        <img
                          src={arrowIcon}
                          alt="nyíl ikon"
                          className="arrow-icon"
                        />
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </aside>
      </section>

      {relatedPosts.length > 0 && (
        <section className="related-posts">
          <h2 className="related-heading">További cikkek</h2>

          <div className="swiper-button-prev custom-nav related-nav">
            <img src={chevronLeft} alt="Előző" />
          </div>
          <div className="swiper-button-next custom-nav related-nav">
            <img src={chevronRight} alt="Következő" />
          </div>

          <Swiper
            className="related-carousel"
            spaceBetween={24}
            slidesPerView={3}
            slidesPerGroup={3}
            loop={true}
            navigation={{
              nextEl: ".swiper-button-next.related-nav",
              prevEl: ".swiper-button-prev.related-nav",
            }}
            pagination={{
              el: ".swiper-pagination.related-pagination",
              clickable: true,
            }}
          >
            {relatedPosts.map((post) => {
              const featured =
                post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || placeholder;

              const description =
                post.excerpt?.rendered
                  ?.replace(/<[^>]+>/g, "")
                  ?.substring(0, 180) + "...";

              return (
                <SwiperSlide key={post.id}>
                  <div className="info-card">
                    <img
                      src={featured}
                      alt={post.title.rendered}
                      className="info-image"
                    />
                    <div className="info-content">
                      <h3
                        className="heading-md"
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />
                      <p>{description}</p>
                      <a href={`/posts/${post.slug}`} className="info-link">
                        Tovább{" "}
                        <img
                          src={arrowIcon}
                          alt="nyíl ikon"
                          className="arrow-icon"
                        />
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}

            <div className="swiper-pagination related-pagination"></div>
          </Swiper>
          <Footer />
        </section>
      )}
    </main>
  );
}
